<template>
  <div id = "debtNoteScheduleReport">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area">
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <div class="page-title"> Debt Note Schedule</div>
          <a href="javascript:void(0)" class="btn btn-secondary pull-right mr-2" v-on:click="exportReports()">
              <i class="fp-export"></i> Export
          </a>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content">
             <data-table-filter-config :moduleName="'debtNoteSchedule'" :allowSameFilter="'allow'"></data-table-filter-config>
             <div class="data-table bg-white overflow-hidden">
               <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
               <section class="data-table bg-white">
                 <custom-pagination
                    :page-changed="onPageChange"
                    :per-page-changed="onPerPageChange" :moduleName="'debtNoteSchedule'" :position="'top'">
                </custom-pagination>
                 <vue-good-table
                      ref="debtNoteScheduleTable"
                      mode="remote"
                      title="Debt Note Schedule"
                      @on-row-click="onRowClick"
                      @on-page-change="onPageChange"
                      @on-selected-rows-change="selectionChanged"
                      @on-column-filter="onColumnFilter"
                      @on-per-page-change="onPerPageChange"
                      @on-sort-change="onSortChange"
                      :totalRows="totalRecords"
                      :columns="userColumns"
                      :rows="rows"
                      :pagination-options="{
                          enabled: false,
                          position: 'bottom',
                          perPage: perPage,
                          perPageDropdown:dropDownPerPage,
                          dropdownAllowAll: false,
                      }"

                      :search-options="{
                      enabled: false,
                      }">
                 </vue-good-table>
                <custom-pagination
                          :page-changed="onPageChange"
                          :per-page-changed="onPerPageChange">
                  </custom-pagination>
               </section>
             </div>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
         <div class="container-fluid">
              <div class="bg-white text-center">
                  <h1>
                      Oops!</h1>
                  <h2>
                      403 </h2>
                  <div class="error-details">
                      Sorry!, You don't have permission to access this page.
                  </div>
              </div>
          </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue';
  
  
  
  
  
  import {commonMixins} from '../../mixins/commonMixins';
  import {dataTableMixins} from '../../mixins/dataTableMixins';
  export default {
    name: "DebtNoteScheduleReport",
    metaInfo: {
      title: "Debt Note Schedule | " +process.env.COPYRIGHT_NAME
    },
    mixins:[commonMixins,dataTableMixins],
    data: () => ({
      permissions:[],
      cantAccessPage:'',
      loading:false,
      userColumns: [],
      columns: [
        {
          label: 'Financier',
          field: 'vendor',
          hidden:false,
          fpFieldType:"text",
          filterable: true

        },
        {
          label: 'Note Reference Number',
          field: 'reference_number',
          hidden:false,
          fpFieldType:"text",
          filterable: true

        },
        {
          label: 'Unit Number',
          field: 'asset_number',
          hidden:false,
          fpFieldType:"text",
          filterable: true

        },
        {
            label: 'Financing Start Date',
            field: 'financing_start_date',
            fpFieldType:"date",
            hidden:false,
            filterable: true

        },
        {
            label: 'Payout Date',
            field: 'end_date',
            fpFieldType:"date",
            hidden:false,
            filterable: true

        },
        {
            label: 'Note Amount',
            field: 'note_amount',
            hidden:false,
            fpFieldType:"integer",
            type:'number',
            filterable: true,

        },
        {
          label: 'Interest Calc Method',
          field: 'intereset_calc_method',
          hidden:false,
          fpFieldType:"option",
          filterable: true,
          filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "intereset_calc_method", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems : ['Actual / Actual', '30 / 360', 'Actual / 360', '30 / 365'], //dropdown (with selected values) instead of text input
            trigger: "enter" //only trigger on enter not on keyup
          },

        },
        {
          label: 'Financing Payment Type',
          field: 'payment_type',
          hidden:false,
          fpFieldType:"option",
          filterable: true,
          filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "payment_type", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems : ['Principal and Interest', 'Fixed Payment', 'Lease Payment'], //dropdown (with selected values) instead of text input
            trigger: "enter" //only trigger on enter not on keyup
          },

        },
        {
          label: 'Principal Payment Type',
          field: 'principal_payment_type',
          hidden:false,
          fpFieldType:"option",
          filterable: true,
          filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "principal_payment_type", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems : ['Fixed Principal', 'Variable Principal'], //dropdown (with selected values) instead of text input
            trigger: "enter" //only trigger on enter not on keyup
          },

        },
        {
          label: 'Interest Rate Type',
          field: 'intereset_rate_type',
          hidden:false,
          fpFieldType:"text",
          filterable: true

        },
        {
            label: 'Payment Date',
            field: 'payment_date',
            fpFieldType:"date",
            hidden:false,
            filterable: true

        },
        {
            label: 'Interest Rate',
            field: 'rate',
            fpFieldType:"integer",
            hidden:false,
            filterable: true

        },
        {
            label: 'Payment Amount',
            field: 'payment_amount',
            hidden:false,
            fpFieldType:"integer",
            type:'number',
            filterable: false, //value = principalAmt + interest
            sortable:false

        },
        {
            label: 'Principal Amount',
            field: 'principal_amount',
            hidden:false,
            fpFieldType:"integer",
            type:'number',
            filterable: true,

        },
        {
            label: 'DB Interest Amount',
            field: 'interest',
            hidden:false,
            fpFieldType:"integer",
            type:'number',
            filterable: true,

        },
        {
            label: 'Note Balance',
            field: 'note_balance',
            hidden:false,
            fpFieldType:"integer",
            type:'number',
            filterable: true,

        },
        {
            label: 'SL Interest Amount',
            field: 'sl_interest',
            hidden:false,
            fpFieldType:"integer",
            type:'number',
            filterable: true,

        },
        {
            label: 'Cumulative DB Interest',
            field: 'cumulative_interest',
            hidden:false,
            fpFieldType:"integer",
            type:'number',
            filterable: true,

        },
        {
            label: 'Cumulative SL Interest',
            field: 'cumulative_sl_interest',
            hidden:false,
            fpFieldType:"integer",
            type:'number',
            filterable: true,

        },
        {
            label: 'Interest Variance',
            field: 'variance',
            hidden:false,
            fpFieldType:"integer",
            type:'number',
            filterable: true,
            sortable:false

        },
        {
          label: 'Principal Posting Status',
          field: 'principal_posted_status',
          hidden:false,
          fpFieldType:"option",
          filterable: true,
          filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "principal_payment_type", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems : ['Posted', 'Not Posted'], //dropdown (with selected values) instead of text input
            trigger: "enter" //only trigger on enter not on keyup
          },

        },
        {
          label: 'Interest Posting Status',
          field: 'interest_posted_status',
          hidden:false,
          fpFieldType:"option",
          filterable: true,
          filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "principal_payment_type", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems : ['Posted', 'Not Posted'], //dropdown (with selected values) instead of text input
            trigger: "enter" //only trigger on enter not on keyup
          },

        },

      ],
      rows: [],
      totalRecords: 0,
      batchProcess:0,
      batchNum:"",
    }),
    watch:{
        permissions: function(permission){
            var self = this;
            permission.forEach(function (permissions) {
                if(permissions.name == 'debt_note_schedule_report') {
                    self.cantAccessPage = true;
                }
            });
        }
    },
    created: function() {
    },
    mounted: function () {

      this.getPermissions();

    },
    methods: {
      // onRowClick(params) {
      //   console.log(params.event.target);
      //   var self = this;
      //    //if data already available than remove it
      //   if ( $(params.event.target.closest('.clickable').nextSibling).hasClass("scheduleDetails")) {
      //       $(params.event.target.closest('.clickable').nextSibling).remove();
      //       return;
      //   }
      //   //generate html
      //   var html = '<tr class="scheduleDetails"><td colspan="12"><table aria-describedby="table" class="table">';
      //       html += '<tr><th>Payment Date.</th><th>Interest Rate</th><th>Payment Amount</th><th>Principal Amount</th><th>DB Interest Amount</th><th>Note Balance</th><th>SL Interest Amount</th><th>Cumulative DB Interest</th><th>Cumulative SL Interest</th><th>Interest Variance</th><th>Principal Posting Status</th><th class="text-right">Interest Posting Status</th></tr>';

      //   var fields = {
      //                   debtNoteId:params.row.id,
      //               };

      //   $.ajax({
      //               url: process.env.ROOT_API + "/debt-note-schedule/details",
      //               type: "POST",
      //               data: fields,
      //               headers: {
      //                   "Accept": "application/json",
      //                   "Authorization": "Bearer " + localStorage.getItem("tkn"),
      //                   "Access-Control-Allow-Headers":
      //                       "Origin, Content-Type, Authorization,X-Requested-With",
      //                   "Cache-Control": "no-cache"
      //               },
      //               dataType: "json",
      //               success: function (data) {

      //                   self.loading = false;
      //                   if ( data.code == 200 ) {

      //                       //check data records
      //                       if ( data.content.length > 0 ) {

      //                           for ( var j=0; j<data.content.length; j++ ) {
      //                               html += '<tr><td>'+data.content[j].payment_date+'</td><td class="vgt-right-align">'+data.content[j].rate+'</td><td class="vgt-right-align">'+data.content[j].payment_amount+'</td><td class="vgt-right-align">'+data.content[j].principal_payment+'</td><td class="vgt-right-align">'+data.content[j].interest+'</td><td class="vgt-right-align">'+data.content[j].note_balance+'</td><td class="vgt-right-align">'+"-"+'</td><td class="vgt-right-align">'+"-"+'</td><td class="vgt-right-align">'+"-"+'</td><td class="vgt-right-align">'+"-"+'</td><td>'+data.content[j].principal_posted_status+'</td><td>'+data.content[j].interest_posted_status+'</td></tr>';
      //                           }

      //                       } else {
      //                           html += '<tr><td colspan="12">No record found.</td></tr>';
      //                       }

      //                       html += '</table></td></tr>';
      //                       $(html).insertAfter(params.event.target.closest('.clickable'));

      //                   }
      //               },
      //               error: function (jqXHR, exception) {

      //                   self.loading = false;
      //                   self.generateStatusCodeMessage(jqXHR,true,'debt-note-schedule-detail');
      //               }
      //           });

      // },
      loadList() {
        //remove row of details if any open
        $('table tr.scheduleDetails').remove();

        var self = this;
        self.loading = true;
        var fields = {
              page: self.serverParams.page,
              perPage: self.serverParams.perPage,
              filters: self.serverParams.columnFilters,
              sort: self.serverParams.sort,
              action:self.action,
        };
        self.firstLoad = 1;
        $.ajax({
              url: process.env.ROOT_API + "/debt-note-schedule/list",
              type: "POST",
              data: fields,
              headers: this.ajxHeaders,
              dataType: "json",
              success: function (data) {
                  self.loading = false;

                  if (data.status == "success") {
                      if ( self.action == "export" ||  self.action == "export_queue") {
                          if ( data.code == "201" ) {
                              alert(data.message);
                          } else {
                              if ( self.action == "export" ) {
                                  self.excel = data.content.web;
                                  var save = document.createElement("a");
                                  save.href = self.excel;
                                  save.download = data.content.web;
                                  save.target = "_blank";

                                  document.body.appendChild(save);
                                  save.click();
                                  document.body.removeChild(save);

                              } else {

                                  self.batchProcess = 1;
                                  self.batchNum = data.content;
                              }
                          }
                          self.action = "list";
                          self.loadList();
                      } else{
                        console.log(data.content.row);
                          self.rows = data.content.row;
                          self.totalRecords = data.content.totalRecords;

                      }
                  }else{
                      self.rows = data.content.row;
                      self.totalRecords = data.content.totalRecords;

                  }
              },
              error: function (jqXHR, exception) {
                  self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'debt-note-schedule')
              }
          });
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/reports/DebtNoteScheduleReport.vue